/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo autocomplete
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var AutoComplete = kendo.ui.AutoComplete;
    if (!AutoComplete || AutoComplete.updated) return;

    var NS = ".kendoAutoComplete",
        proxy = $.proxy,
        support = kendo.support,
        Widget = kendo.ui.Widget,
        PLACEHOLDER = "placeholder",
        FOCUSED = "k-state-focused",
        AVATAR = "avatar",
        ATTR_TITLE = "title",
        ATTR_VAL_UI_TYPE = "valUi",
        DEFAULT = 'k-state-default',
        SEARCH_ICON = 'v-icon-search',
        DISABLED = 'disabled',
        STATEDISABLED = 'k-state-disabled',
        READONLY = 'readonly',
        STATEREADONLY = "k-state-readonly",
        ARIA_READONLY = 'aria-readonly',
        HOVEREVENTS = 'mouseenter' + NS + ' mouseleave' + NS;

    /**
     * Placeholder updates for AutoComplete widget.
     */
    function autoCompleteSearch() {
        var self = this;
        clearTimeout(self._typing);
        self._typing = setTimeout(
            function () {
                self._placeholder();
                if (self._prev === self._accessor()) return;
                self._prev = self._accessor();
                self.search();
            },
            self.options.delay
        );
    }

    function autoCompleteEditable(options) {
        var self = this,
            element = self.element,
            wrapper = self.wrapper.off(NS),
            readonly = options.readonly,
            disable = options.disable;

        if (!readonly && !disable) {
            wrapper
                .addClass(DEFAULT)
                .addClass(SEARCH_ICON)
                .removeClass(STATEDISABLED)
                .removeClass(STATEREADONLY)
                .on(HOVEREVENTS, self._toggleHover);
            element
                .removeAttr(DISABLED)
                .removeAttr(READONLY)
                .attr(ARIA_READONLY, false);
        } else {
            if (readonly) {
                wrapper.addClass(STATEREADONLY).removeClass(DEFAULT).removeClass(STATEDISABLED);
            }
            if (disable) {
                wrapper.addClass(STATEDISABLED).removeClass(DEFAULT).removeClass(STATEREADONLY);
            }
            element.attr(DISABLED, disable).attr(READONLY, readonly).attr(ARIA_READONLY, readonly);
        }
    }

    /**
     * The original widget "class" gets updated in two steps. First is constructor
     * update. newInit function becomes the new constructor of the component.
     * In the constructor the widget is also republished as kendo plugin, so that
     * jQuery.fn gets updated. Second step is overriding of specific widget methods
     * when needed.
     */
    var oldAutoCompleteInit = AutoComplete.fn.init,
        newAutoCompleteInit = function (element, options) {
            var self = this,
                $element = $(element);
            // update options from specifically prefixed data on element
            options = kendo.elementOptions($element, "autocomplete", options);
            if (options.enabled === undefined)
                options.enabled = !$element.is("[disabled]");
            // remove avatar class before the wrapper gets created
            $element.removeClass(AVATAR);
            // call original constructor
            oldAutoCompleteInit.call(self, element, options);
            // update placeholder in options to be sure
            self.options.placeholder = self.options.placeholder || self.element.attr(PLACEHOLDER);
            // remember title text - needed for various description UI types
            // execute with caution to not remove the title by mistake
            self.options.titleText = self.options.titleText || self.element.attr(ATTR_TITLE);
            self.element.removeAttr(ATTR_TITLE);
            // update validation UI type in options to be sure
            self.options.validationUi = self.options.validationUi || self.element.data(ATTR_VAL_UI_TYPE);
            // monitor keystrokes for placeholder
            if (!support.placeholder && typeof self._keyup == "function")
                self.element.on("keyup" + NS, proxy(self._keyup, self));
            // always hides placeholder on focus originally
            // so remove this from event handler;
            // also we add placeholder checking in _search()
            self.element
                .off("focus" + NS)
                .on("focus" + NS, function () {
                    self._prev = self._accessor();
                    self.wrapper.addClass(FOCUSED);
                })
                .on("cut" + NS, proxy(self._search, self));
            // update title / tooltip popups
            Widget.fn.descriptionUi.call(self);
            // remove input class from wrapper for easier styling
            self.wrapper.removeClass("k-input");
        };

    AutoComplete = AutoComplete.extend({
        // new init
        init: newAutoCompleteInit,
        // default options extension
        options: kendo.getUpdatedWidgetOptions(),
        // updated methods
        _search: autoCompleteSearch,
        _editable: autoCompleteEditable
    });

    kendo.updatePlaceholderLogic(AutoComplete);

    AutoComplete.updated = true;

    kendo.ui.plugin(AutoComplete);

})(window.kendo.jQuery);
